import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Button from '../../Core/Button';
import Container from '../../Core/Container';

export const StyledContainer = styled(Container)`
  width: 100%;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 16px auto 56px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.white')};
  padding: 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 60px 30px;
    flex-direction: row;
    justify-content: space-between;
    padding: 32px;
  }
`;

export const Content = styled.div`
  flex: 0 0 auto;
  margin: 0 auto;
  transition: all 500ms;
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  min-height: 40px;

  /* This fires as soon as the element enters the DOM */
  /* This will be the styles applied to the element as it starts to enter. It will animate from these values to the values provided in enter-active */
  &.fade-enter {
    opacity: 0;
  }
  /* This is where we can add the transition*/
  &.fade-enter-active {
    opacity: 1;
  }
  /* This fires as soon as the state is false */
  /* This will be the styles applied to the element as it starts to exit. It will animate from these values to the values provided in exit-active */
  &.fade-exit {
    opacity: 1;
  }
  /* fires as element leaves the DOM*/
  &.fade-exit-active {
    opacity: 0;
  }

  &.fade-enter-active,
  &.fade-exit-active {
    transition: opacity 500ms;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  p {
    font-size: 1.5rem;
    font-weight: ${themeGet('fontWeights.medium')};
    transition: all 350ms;
    line-height: 32px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  margin: 1.5rem auto 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0;
  }
`;

export const CtaButton = styled(Button)`
  margin: 0 0.5rem;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0 0.75rem;

    &:first-child {
      margin-left: 30px;
    }

    &:last-child {
      margin-right: 0.75rem;
    }
  }
`;

export const Form = styled.form`
  margin: 35px 0 0 0;
  transition-property: all;
  transition-duration: ${({ duration }) => `${duration}ms`};
  overflow: hidden;
  width: 100%;
  max-width: 500px;
  transform-origin: top;

  /* This fires as soon as the element enters the DOM */
  /* This will be the styles applied to the element as it starts to enter. It will animate from these values to the values provided in enter-active */
  &.form-transition-enter {
    max-height: 0;
    opacity: 0;
  }
  /* This is where we can add the transition*/
  &.form-transition-enter-active {
    max-height: 800px;
    opacity: 1;
  }
  /* This fires as soon as the state is false */
  /* This will be the styles applied to the element as it starts to exit. It will animate from these values to the values provided in exit-active */
  &.form-transition-exit {
    max-height: 800px;
    opacity: 1;
  }
  /* fires as element leaves the DOM*/
  &.form-transition-exit-active {
    max-height: 0px;
    opacity: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 50px 0 0 0;
  }
`;

export const Fieldset = styled.fieldset``;

export const Legend = styled.legend`
  /* margin: 46px 0 33px; */
  font-size: 20px;
  font-weight: ${themeGet('fontWeights.medium')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 20px;
`;

export const FormGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 15px 0;
  padding: 0 0 0 5px;
`;

export const RadioInput = styled.input.attrs(() => ({
  type: 'radio',
}))`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const CustomRadio = styled.span`
  display: flex !important;
  justify-content: center;
  align-items: center;
  min-width: 18px;
  min-height: 18px;
  border-radius: 50%;
  border: 0.125em solid currentColor;
  transform: translateY(-0.05em);
  color: ${themeGet('colors.velvet')};
  margin: 0 10px 0 0;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    background-color: currentColor;
    border-radius: 100%;
    transition: 180ms transform ease-in-out;
    transform: scale(0);
  }

  ${RadioInput}:focus + & {
    box-shadow:
      0 0 0 0.05em #fff,
      0 0 0.15em 0.1em currentColor;
  }

  ${RadioInput}:checked + & {
    &::before {
      transform: scale(1);
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const InputLabel = styled.label`
  /* margin: 0 0 0 17px; */
  font-size: 18px;
  font-weight: ${themeGet('fontWeights.normal')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: left;

  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SubmitBtn = styled(Button)`
  margin-top: 20px;
`;
